export const RESTRICTIONS_FOR_DISPLAY = [
    'entranceForRussians',
    'flightsAvailability',
    'pcrExpirationPeriodInHoursOrRequired',
    'quarantineRequired',
    'tourismAvailability',
    'vaccineRequired',
    'visaRequired',
];
